'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import IonSpinner from '../../../_libs/reactionic/src/components/ionSpinner';


export function ImageView(props) {
  if (props.hasError) {
    // TODO: implement error display
    return null;
  } else if (props.isLoading) {
    return (
      <div className={classNames("Image", props.className)}>
        <div className="Image__spinnerContainer">
          <IonSpinner
            className="Image__spinner"
            style={props.style}
          />
        </div>
      </div>
    );
  } else {
    return (
      <img
        className={classNames("Image", props.className)}
        style={props.style}
        src={props.url}
      />
    );
  }
}

ImageView.propTypes = {
  className: T.string,
  style: T.object,
  isLoading: T.bool,
  url: T.string,
  hasError: T.bool,
};

ImageView.defaultProps = {
  className: '',
  isLoading: true,
};



// WEBPACK FOOTER //
// ./src/js/files/components/Image/ImageView.js